import * as actionTypes from 'constants/ActionTypes';

const letter = (state = { isLoaded: false }, action) => {
    switch (action.type) {
    case actionTypes.REMOVE_LETTER:
        return {
            isLoaded: false,
        };
    case actionTypes.GET_LETTER.REQUEST:
        return {
            ...state,
            isLoaded: false,
        };
    case actionTypes.GET_LETTER.SUCCESS:
        return {
            ...action.data,
            isLoaded: true,
        };
    case actionTypes.GET_LETTER.FAILURE:
        return {
            ...state,
            isLoaded: true,
        };
    case actionTypes.UPDATE_LETTER.REQUEST:
        return {
            ...state,
        };
    case actionTypes.UPDATE_LETTER.SUCCESS: {
        return {
            ...action.data,
        };
    }
    case actionTypes.UPDATE_LETTER.FAILURE:
        return {
            ...state,
        };
    default:
        return state;
    }
};

export default letter;



// WEBPACK FOOTER //
// ./app/reducers/letter.js